import React from "react"
import {FieldAutomationConditionFormProps} from "../../../../../render/automation-condition-form";
import FieldFormElementView from "../../../../../render/form-elemnent-view";


const debug = false
// const debug = "MultiselectConditionForm"

export default class FieldTaskTypes_AutomationConditionForm extends React.Component<FieldAutomationConditionFormProps> {


    constructor(props:FieldAutomationConditionFormProps) {
        super(props)
    }

    onChangeValue = (value:any) => {
        this.props.onChangeCallback({
            fieldValues     : value
        })
    }

    render() {
        debug && console.log(debug, 'render')

        const modelValue = {
            [this.props.field.fieldId]  : this.props.config.fieldValues
        }

        return (
            <div className="flex-row-left-top">
                <div className="label">is</div>
                <FieldFormElementView field={this.props.field} onChange={this.onChangeValue} model={modelValue} className="w-300" />
            </div>
        )
    }
}